import {theme} from 'antd'
import {antdTokens} from '@shared/theme/tokens.mjs'

const {defaultAlgorithm, darkAlgorithm} = theme

export const lightTheme = {
  cssVar: true,
  algorithm: defaultAlgorithm,
  token: {
    ...antdTokens.light,
  },
  components: {
    Button: {
      borderRadius: antdTokens.light.borderRadius,
      fontWeight: 500,
      controlHeight: 40,
    },
    Card: {
      borderRadiusLG: antdTokens.light.borderRadiusLG,
      colorBorderSecondary: 'transparent',
      headerBg: 'transparent',
    },
    Modal: {
      colorBgMask: 'rgba(15, 23, 42, 0.97)',
      borderRadiusLG: antdTokens.light.borderRadiusLG,
      paddingMD: antdTokens.light.padding,
      paddingLG: antdTokens.light.paddingLG,
    },
    Input: {
      borderRadius: antdTokens.light.borderRadius,
      activeShadow: 'none',
      hoverBorderColor: 'var(--color-border-strong)',
    },
    InputNumber: {
      borderRadius: antdTokens.light.borderRadius,
      activeShadow: 'none',
      hoverBorderColor: 'var(--color-border-strong)',
    },
    Select: {
      borderRadius: antdTokens.light.borderRadius,
      optionSelectedFontWeight: 500,
    },
    DatePicker: {
      borderRadius: antdTokens.light.borderRadius,
      activeShadow: 'none',
    },
  },
}

export const darkTheme = {
  cssVar: true,
  algorithm: darkAlgorithm,
  token: {
    ...antdTokens.dark,
  },
  components: {
    Button: {
      borderRadius: antdTokens.dark.borderRadius,
      fontWeight: 500,
      controlHeight: 40,
    },
    Card: {
      borderRadiusLG: antdTokens.dark.borderRadiusLG,
      colorBorderSecondary: 'transparent',
      headerBg: 'transparent',
    },
    Modal: {
      colorBgMask: 'rgba(15, 23, 42, 0.97)',
      borderRadiusLG: antdTokens.dark.borderRadiusLG,
      paddingMD: antdTokens.dark.padding,
      paddingLG: antdTokens.dark.paddingLG,
    },
    Input: {
      borderRadius: antdTokens.dark.borderRadius,
      activeShadow: 'none',
      hoverBorderColor: 'var(--color-border-strong)',
    },
    InputNumber: {
      borderRadius: antdTokens.dark.borderRadius,
      activeShadow: 'none',
      hoverBorderColor: 'var(--color-border-strong)',
    },
    Select: {
      borderRadius: antdTokens.dark.borderRadius,
      optionSelectedFontWeight: 500,
    },
    DatePicker: {
      borderRadius: antdTokens.dark.borderRadius,
      activeShadow: 'none',
    },
  },
}
